export * from './page-tab.component';
